import { z } from 'zod';

const RTESchema = z.union([z.record(z.string(), z.unknown()), z.array(z.unknown())]);

export { RTESchema };
